module.exports = __webpack_public_path__ + "img/splash.8dc2f81b.png";